import { render, staticRenderFns } from "./TripNote.vue?vue&type=template&id=0cbb4270&"
import script from "./TripNote.vue?vue&type=script&lang=js&"
export * from "./TripNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports